import { IconButton, Stack } from "@mui/material";
import React from "react";
import EraserIcon from "../../../assets/icons/EraserIcon";
import CanvasBrushSizeSlider from "../CanvasBrushSizeSlider/CanvasBrushSizeSlider";
import { calcCanvasAndModelDim } from "../../../lib/CalcCanvasAndModelDim";
import EditIcon from "@mui/icons-material/Edit";
import { colors } from "../../../constants/site-content";
import { connect } from "react-redux";

interface CanvasDrawingToolbarProps {
  leftHand: boolean;
  lineWidth: number;
  handleBrushSizeChange: (lineWidth: number) => void;
  canvasWidth: number;
  setEraserEnabled: (eraserEnabled: boolean) => void;
  eraserEnabled: boolean;
}
export const CanvasDrawingToolbar = ({
  lineWidth,
  handleBrushSizeChange,
  canvasWidth,
  setEraserEnabled,
  eraserEnabled,
  ...props
}: CanvasDrawingToolbarProps & any) => {
  const { isWrapped } = calcCanvasAndModelDim();

  return (
    <Stack
      gap={1}
      direction={"column"}
      sx={{
        position: "absolute",
        bottom: isWrapped
          ? "calc(25% - (292px / 2))"
          : "calc(50% - (292px / 2))",
        right: props.leftHand ? "initial" : "8px",
        left: props.leftHand ? "8px" : "initial",
        zIndex: 100,
        borderRadius: "25%",
        padding: "8px",
        height: "auto",
        width: "auto",
        alignItems: "center",
      }}
    >
      {lineWidth > 0 && (
        <CanvasBrushSizeSlider
          handleBrushSizeChange={handleBrushSizeChange}
          size={lineWidth}
          canvasWidth={canvasWidth}
        />
      )}
      <IconButton
        onClick={() => setEraserEnabled(false)}
        style={{
          width: "40px",
          height: "40px",
          borderRadius: "50%",

          zIndex: 100,
          border: eraserEnabled ? "initial" : `2px solid ${colors.brandColor}`,
        }}
      >
        {eraserEnabled ? (
          <EditIcon sx={{ color: "#000" }} />
        ) : (
          <EditIcon sx={{ color: "#000" }} />
        )}
      </IconButton>
      <IconButton
        onClick={() => setEraserEnabled(true)}
        style={{
          width: "40px",
          height: "40px",
          borderRadius: "50%",
          zIndex: 100,
          border: eraserEnabled ? `2px solid ${colors.brandColor}` : "initial",
        }}
      >
        {eraserEnabled ? <EraserIcon /> : <EraserIcon />}
      </IconButton>
    </Stack>
  );
};

const mapStateToProps = (state) => {
  const { leftHand } = state;
  return { leftHand };
};
const mapDispatchToProps = () => {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CanvasDrawingToolbar);
